export default __webpack_public_path__ + "static/media/angbao-bonus.5ee87ea6.webp";